import * as React from 'react'

import { motion, Variants } from 'framer-motion'

interface Props {
  children?: React.ReactNode
  animation?: 'fade_bottom' | 'fade_right'
}

const Animators = ({ children, animation = 'fade_bottom' }: React.PropsWithChildren<Props>) => {
  const items = children ? React.Children.toArray(children).filter(Boolean) : []

  return (
    <motion.div key={items.length} variants={Overlay} initial="hidden" animate="show">
      {items.map((child, idx) => (
        <Animation key={`anim_${idx}`} animation={animation}>
          {child}
        </Animation>
      ))}
    </motion.div>
  )
}

export default Animators

const Overlay = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

const ItemFade: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.2,
      ease: 'easeInOut',
    },
  },
}

const ItemFadeBottom: Variants = {
  hidden: { opacity: 0, y: 80 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'tween',
      duration: 0.2,
      ease: 'easeInOut',
    },
  },
}

const ItemFadeRight: Variants = {
  hidden: { opacity: 0, x: 80 },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      type: 'tween',
      duration: 0.2,
      ease: 'easeInOut',
    },
  },
}

const ItemFadeTop: Variants = {
  hidden: { opacity: 0, y: -80 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'tween',
      duration: 0.2,
      ease: 'easeInOut',
    },
  },
}

const innerStyle = {
  display: 'flex',
  flexDirection: 'column',
} as const

interface AnimationProps {
  children?: any
  animation?: 'fade_bottom' | 'fade_right' | 'fade_top' | 'fade'
}

const Animation = ({ animation = 'fade_bottom', children }: AnimationProps) => {
  switch (animation) {
    case 'fade':
      return (
        <motion.div style={innerStyle} variants={ItemFade}>
          {children}
        </motion.div>
      )
    case 'fade_bottom':
      return (
        <motion.div style={innerStyle} variants={ItemFadeBottom}>
          {children}
        </motion.div>
      )
    case 'fade_top':
      return (
        <motion.div style={innerStyle} variants={ItemFadeTop}>
          {children}
        </motion.div>
      )
    case 'fade_right':
      return (
        <motion.div style={innerStyle} variants={ItemFadeRight}>
          {children}
        </motion.div>
      )
  }
}

const SimpleAnimation = ({ animation = 'fade_bottom', children }: AnimationProps) => {
  return (
    <motion.div variants={Overlay} initial="hidden" animate="show">
      <Animation animation={animation}>{children}</Animation>
    </motion.div>
  )
}

export { SimpleAnimation as Animation }
